/* SQINWEAR · Al añadir desde la ficha o desde una tarjeta de colección se abre la cesta (antes, desde la colección solo salía un mensaje en el recuadro de tallas).
   + Info de talla (metacampo custom.info_talla) pequeña dentro del bloque blanco de tallas al añadir desde colección en móvil. */
(function(){
  if (window.__sqAddOpens) return; window.__sqAddOpens = true;
  var st=document.createElement('style');
  st.textContent='.sq-card-fit{display:none}@media (max-width:749px){.sq-card-fit{display:block;width:100%;margin:0!important;padding:14px 16px 2px;background:#fff;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;font-size:11px;font-weight:400;line-height:1.4;letter-spacing:.04em;color:#6f6a69;text-align:center;text-transform:uppercase;box-sizing:border-box}}';
  document.head.appendChild(st);
  function closeSizes(){ document.querySelectorAll('.js-sizes-content.is-visible').forEach(function(s){ s.classList.remove('is-visible'); }); }
  function patch(){
    var C=customElements.get('cart-drawer'); if(!C) return false; if(C.prototype.__sqAdded) return true;
    var orig=C.prototype.renderContents;
    C.prototype.renderContents=function(res, open){
      if(res && res.product_title && res.variant_id && !res.items){
        var self=this; closeSizes();
        var r=orig.call(this, res, true);
        /* la tarjeta de colección libera el scroll a los 4 s; si la cesta sigue abierta, se vuelve a bloquear */
        setTimeout(function(){ if(self.classList.contains('is-visible')){ document.body.style.overflow='hidden'; } }, 4100);
        return r;
      }
      return orig.apply(this, arguments);
    };
    var origClose=C.prototype.close;
    C.prototype.close=function(){ var r=origClose.apply(this, arguments); document.body.style.overflow=''; return r; };
    C.prototype.__sqAdded=true; return true;
  }
  if(!patch() && window.customElements){ customElements.whenDefined('cart-drawer').then(patch); }
})();
